import { title, mlAuto, mrAuto } from "assets/jss/material-kit-pro-react.jsx";

const featuresStyle = {
  featuresSection: {
    padding: "80px 0px"
  },
  textCenter: {
    textAlign: "center"
  },
  title,
  mlAuto,
  mrAuto
};

export default featuresStyle;
